import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const card = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 180px;
  padding: var(--space-300);
  overflow: hidden;
  white-space: initial;
  text-decoration: none;
  background-color: var(--background-primary);
  border: none;
  border-radius: var(--rounding-m);
  outline: none;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.6);
  cursor: pointer;
  &:hover {
    box-shadow: inset 0 0 1px #000000;
  }
  & .imgWrap {
    position: absolute;
    top: 0;
    right: 0;
  }
  &[data-size='sm'] {
    width: 180px;
    padding: var(--space-250);
    background-position: right top;
    ${breakpoints.only.desktop} {
      width: 180px;
    }
    ${breakpoints.only.tablet} {
      width: 180px;
      padding: var(--space-200);
    }
    ${breakpoints.only.mobile} {
      width: 100%;
      min-height: 92px;
      padding: var(--space-200);
      margin: 0 0 20px 0;
    }
    & .imgWrap {
      width: 112px;
      height: 80px;
      ${breakpoints.only.mobile} {
        width: 88px;
        height: 64px;
      }
      overflow: hidden;
      & picture {
        display: block;
        width: 100%;
        height: 100%;
        & img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  &[data-size='lg'] {
    align-items: baseline;
    width: 380px;
    & .imgWrap {
      width: 100%;
      height: 100%;
      & picture {
        & img {
          position: absolute;
          right: 0;
          bottom: 0;
          max-width: calc(100% - 180px);
          max-height: 100%;
        }
      }
    }

    background-position: calc(100% - 15px) bottom;
    ${breakpoints.only.desktop} {
      width: 460px;
      & .imgWrap {
        right: calc(0% - 15px);
      }
    }
    ${breakpoints.only.tablet} {
      width: 324px;
      & .imgWrap {
        right: calc(0% - 30px);
      }
    }
  }
`;
export const cardTitle = css`
  margin-bottom: 4px;
  text-align: left;
  color: #333333;
  &[data-size='lg'] {
    max-width: 152px;
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
  }
  &[data-size='sm'] {
    max-width: 136px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
`;
export const cardDesc = css`
  display: -webkit-box;
  overflow: hidden;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  color: #666666;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  &[data-size='lg'] {
    max-width: 152px;
    font-size: 14px;
    line-height: 18px;
  }
  &[data-size='sm'] {
    max-width: 136px;
    font-size: 12px;
    line-height: 16px;
  }
`;
export const cardText = css`
  ${breakpoints.from.tablet} {
    position: absolute;
    top: 100px;
  }
`;
